





















import { Component, Mixins, Prop } from "vue-property-decorator";
import { LightRow, Header } from "../../../../domain/system/table";

@Component({
  components: {
  },
})
export default class LightScrollableTableRow extends Mixins() {
  @Prop()
  row: LightRow;

  @Prop()
  headers: Header[];

  getCellContentClassProperties(cellIndex: number): string {
    return this.row.isCellSelected(cellIndex) ? "selected" : undefined;
  }

  getCellContentStyleProperties(cellIndex: number): any {
    return {
      width: this.headers[cellIndex] ? this.headers[cellIndex].width + "px" : null,
      display: this.getCellVisible(cellIndex) ? null : "none",
    };
  }

  getCellVisible(cellIndex: number): boolean {
    return !this.headers[cellIndex] || this.headers[cellIndex].isVisible;
  }

  onCellClickedWithCtrl(cellIndex: number): void {
    this.$emit("rowClicked", this.row, cellIndex, true);
  }

  onCellClicked(cellIndex: number): void {
    this.$emit("rowClicked", this.row, cellIndex, false);
  }

  onCellDoubleClicked(cellIndex: number): void {
    this.$emit("rowDoubleClicked", this.row, cellIndex);
  }
}
